import React from "react";

export default function Loader({ text = "Loading data..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-6 text-gray-600">
      <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-2"></div>
      <p className="text-sm">{text}</p>
    </div>
  );
}
